import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuthStore } from '../stores/auth.store';
import { useIsAdmin } from '../hooks/useIsAdmin';
import { AdminWorkspacePage } from '@/features/admin/workspaces';

export const Route = createFileRoute('/admin/workspace/$workspaceId')({
  component: AdminWorkspaceDetailRoute,
});

function AdminWorkspaceDetailRoute() {
  const user = useAuthStore((state) => state.user);
  const { isAdmin, loading } = useIsAdmin();
  const { workspaceId } = Route.useParams();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (loading && isAdmin === null) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4" />
          <p className="text-gray-600 dark:text-gray-400">Verificando permissões...</p>
        </div>
      </div>
    );
  }

  if (isAdmin === false) {
    return <Navigate to="/workspaces" />;
  }

  return <AdminWorkspacePage workspaceId={workspaceId} />;
}
